export default __webpack_public_path__ + "static/icon_events-ed5b29ba77c9e1cf746b44bf7933fae4.png";